import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import Icon from './Icon'
import style from './Card.less'

class Card extends Component {
    static propTypes = {
        kind: PropTypes.string,
        position: PropTypes.string,
        justified: PropTypes.bool,
        grouped: PropTypes.bool,
        active: PropTypes.bool,
        status: PropTypes.string,
        header: PropTypes.node.isRequired,
        help: PropTypes.node,
        addon: PropTypes.node,
        onClick: PropTypes.func
    }

    render() {
        const {children, kind, position, justified, grouped, active, status, header, help, addon, onClick} = this.props
        var kindClass = kind && kind.toLowerCase()
        var positionClass = position && position.toLowerCase()
        var statusClass = status && status.toLowerCase()

        return (
            <div className={cx(style.default, style[kindClass], style[statusClass], style[positionClass], {[style.clickable]: onClick, [style.justified]: justified, [style.grouped]: grouped, [style.active]: active})}>
                <div className={style.header}>
                    <div
                        className={style.headerMain}
                        onClick={onClick}>
                    	<div className={style.headerMainContent}>
                    		{addon && (
                                <div className={style.addon}>
                                    {addon}
                                </div>
                            )}
                    		<div className={style.container}>
                        		{header}
                        	</div>
                        </div>
                    </div>
                    {help && (
                        <div className={style.headerSide}>
                            {help}
                        </div>
                    )}
                </div>
                <div
                    className={style.body}
                    onClick={onClick}>
                    <div className={style.bodyContent}>
					   {children}
                    </div>
                </div>
            </div>
        )
    }
}

export default Card


// WEBPACK FOOTER //
// ./lib/core/components/Card.js